import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  RemoveEstimateSectionMutation as RemoveEstimateSectionMutationResult,
  Scalars,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { hydrateEstimateCaches } from './hydrateEstimateCaches';

const RemoveEstimateSectionMutation = graphql(`
  mutation RemoveEstimateSection($id: ID!) {
    removeEstimateSection(id: $id) {
      ...EstimateBuilderEstimate
      preview {
        template
        context
        pendingSolarLayoutImage
      }
    }
  }
`);

type Variables = {
  id: Scalars['ID']['input'];
};

const useRemoveEstimateSection = (args: {
  projectId: string;
  estimateId: string;
  options?: UseMutationOptions<
    RemoveEstimateSectionMutationResult,
    Error,
    Variables
  >;
}) => {
  const { projectId, estimateId } = args;
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args.options ?? {};

  return useMutation<RemoveEstimateSectionMutationResult, Error, Variables>({
    mutationFn: ({ id }) => {
      return gqlClient.request(RemoveEstimateSectionMutation, { id });
    },
    onSuccess: (data, variables, context) => {
      hydrateEstimateCaches(queryClient, {
        projectId,
        estimateId,
        estimate: data.removeEstimateSection,
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useRemoveEstimateSection;
